export default "__VITE_ASSET__BOyO_hu9__"